import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchPatientBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Mutation hook for updating a patient's demographics. Invalidates the patient query on success. */
export function useUpdatePatient(patientId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PatchPatientBody) => {
      const response = await api.patch('/patients/:patientId', { params: { patientId }, body })
      if (!response.success) throw new Error(response.error.message)
      return response.data.patient
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patient', patientId] })
    },
  })
}
